<template>
  <div id="wrapper__right" class="d-lg-block d-md-block" style="min-Width:245px;"> 
      <div class="rm-header">
              <div id="rm-info" class="textlabel" :data-label="this.$t('RigthBar.patInfo')">
                    <p id="rm-name" class=" text-truncate"><span>{{this.DataHeader.title}}</span> {{this.DataHeader.firstName}}</p>
                    <p id="rm-surname" class=" text-truncate">{{this.DataHeader.lastName}}</p>
              </div>



              <div :id="targetId" oncontextmenu="return false;" tabindex="0">
                <div id="rm-frame">
                  <ejs-contextmenu :target="menuTargetId" :id="targetId" :items='menuItems' :select='onSelect'></ejs-contextmenu>
                  <input type="file" ref="input" hidden value="" @change="addImage($event)"/>
                  <img v-on:click="OnCamera" v-if="this.Photo.contents !== null && this.Photo.contents !== ''" id="rm-photo" v-bind:src="'data:image/'+this.Photo.extension+';base64,'+this.Photo.contents" data-toggle="modal" data-target="#exampleModalScrollable">
                  <img v-on:click="OnCamera" v-if="this.Photo.contents === null || this.Photo.contents === ''" id="rm-photo" src="@/assets/images/faces/nopic-male.jpg" data-toggle="modal" data-target="#exampleModalScrollable">             
                  <div v-on:click="GoToPatientSummary" class="rm-more">{{ $t('Shared.Details') }}</div>
                </div>
              </div>



                    <p v-if="this.DataHeader.patientCode" id="rm-summary" class="text-truncate pull-left">ID {{this.DataHeader.patientCode}}</p>
                    <div class="bottomShadow"></div>
                    <i v-if="this.DataHeader.allergies && !this.DataHeader.specialPrecaution" id="rm-allergic" class="mdi mdi-alert text-warning allergies" v-b-tooltip.hover.bottomleft="`${$t('RigthBar.ALLERGIC')}: ${this.DataHeader.allergies}`" variant="primary"></i>
                    <i v-if="this.DataHeader.specialPrecaution && !this.DataHeader.allergies" id="rm-allergic" class="mdi mdi-alert text-warning allergies" v-b-tooltip.hover.bottomleft="`${$t('RigthBar.SPECIALPR')}: ${this.DataHeader.specialPrecaution}`" variant="primary"></i>
                    <i v-if="this.DataHeader.specialPrecaution && this.DataHeader.allergies" id="rm-allergic" class="mdi mdi-alert text-warning allergies" v-b-tooltip.hover.bottomleft="`${$t('RigthBar.ALLERGIC')}: ${this.DataHeader.allergies} / ${$t('RigthBar.SPECIALPR')}: ${this.DataHeader.specialPrecaution}`" variant="primary"></i>
              </div>
                 <marquee v-on:click="GoToPatientSummary" data-toggle="modal" data-target="#exampleModalScrollable" id="rm-marquee" scrollamount="4" truespeed="true" >
                  <small v-if="this.DataHeader.dob">{{ $t('Shared.Dob') }}:</small> {{this.DataHeader.dob}}<span v-if="this.DataHeader.dob">///</span>
                  <small v-if="this.DataHeader.ageFormatted">{{ $t('Shared.Age') }}:</small> {{this.DataHeader.ageFormatted}}<span v-if="this.DataHeader.ageFormatted">///</span>
                  <small v-if="this.DataHeader.gender">{{ $t('Shared.Sex') }}: {{$t('Shared.'+this.DataHeader.gender)}}</small> <span v-if="this.DataHeader.gender">///</span>            
                  <small v-if="this.DataHeader.cellPhone">{{ $t('Shared.CellPhone') }}:</small> {{this.DataHeader.cellPhone}}<span v-if="this.DataHeader.cellPhone">///</span>             
                  <small v-if="this.DataHeader.allergies">{{$t('MdPatientAllergies.Allergies')}}:</small>{{this.DataHeader.allergies}}<span v-if="this.DataHeader.allergies">///</span>
                  <small v-if="this.DataHeader.specialPrecaution">{{$t('SpecialPrecautions.PatientSpecialPrecautions')}}:</small>{{this.DataHeader.specialPrecaution}}<span v-if="this.DataHeader.specialPrecaution">///</span>
                  <small v-if="this.DataHeader.email">{{ $t('Shared.Email') }}:</small> {{this.DataHeader.email}}
                </marquee>
                <div class="rm-options">
                    <div class="bloodhound">
                      <input class="typeahead menu-search" type="text"
                        ref="search_"
                        onfocus="this.removeAttribute('readonly');"
                        onblur="this.setAttribute('readonly',true);" readonly
                        :placeholder="$t('HeaderLeftMenu.sMenu')" v-model="searchOptModel"
                        v-on:input="searchOpt"
                      >
                      <a v-on:click="resetNow()" tabindex="-1"><i class="center-icons ikon med-cross"></i></a>
                    </div>
                    <div id="rm-items">
                         <item 
                         v-bind:ItemList="this.$attrs.ItemList" 
                         v-bind:itemdisabled="this.$attrs.itemdisabled"
                         v-bind:PatientCode="this.$attrs.PatientCode" 
                         v-bind:active_el="this.$attrs.active_el"                        
                         />
                         <small>{{ $t('GroupNotesItemRightBar.OptionMenu') }}</small>
                    </div>
                </div>

                <ModalCamera
                v-bind:TitleWindow="$t('GroupNotesRightBar.TakePic')"
                v-bind:ModalId="this.modalIdCamera"                
                >
              </ModalCamera>
  </div>



</template>

<script>
import Item from '@/components/template/items/Item'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '../../../common/utils'
//import PatientService from '@/services/patient.service'
import { EventBus } from '../../../event-bus.js';
import DocumentManagementService from '@/services/documentmanagement.service' 
import Vue from 'vue';
import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";
Vue.use(ContextMenuPlugin);

export default {  
  name: 'RigthBar',
  mixins: [DBFunctions],
  components:{Item},
  data(){
    return{
      DataHeader:{
        age:null,
        ageFormatted:"",
        allergies:"",
        attendingDoctor:"",
        cellPhone:"",
        dob:null,
        email:null,
        firstName:"",
        gender:"",
        lastName:"",
        patientAddress:"",
        patientCode:"",
        primaryInsurance:null,
        title:"",
        specialPrecaution: ""
      },
      modalIdCamera:"modalIdCamera",
      menuItems:[],
      PatientCode:this.$route.params.id,
      menuTargetId:"#target-menu-righmenu",
      targetId:"target-menu-righmenu",
      NotPhoto:true,
      Photo:{      
        contents:"",
        extension:"", 
        fileName:"",   
      },
      msg: this.$t('Msg.SavedSuccessfully'),
      message:this.$t('Layout.displayedScreen'),
      searchOptModel:''
    }
  },
 
  methods: {
    setDataHeader(){
      console.log(this.DataHeader);      
      //this.$set(this.DataHeader, 'lastName', data.lastName);
    },
    loadMenuItems(from) {
      const indexToRemove = this.menuItems.findIndex(item => item.id === 'RemoveUserPicture');
      if(!from){
        this.menuItems.push({text: this.$t('GroupNotesRightBar.LoadPic'),id:"LoadPicture"})
        this.menuItems.push({text: this.$t('GroupNotesRightBar.TakePic'),id:"TakePicture"})
      }
      if(this.Photo.contents){
        if( indexToRemove == -1){
          this.menuItems.push({text: this.$t('GroupNotesRightBar.RemovePic'), id: "RemoveUserPicture"})
        } 
      } else {
          if (indexToRemove !== -1) {
              this.menuItems.splice(indexToRemove, 1);
          }
      }
    },

    formatterDateToString(date){
        return Utils.formatterDateToString(date);
		},

    async GetDataHeader(){
      this.DataHeader = await this.getData(this.$route.params.id);   
      this.DataHeader.age = this.DataHeader.age === 0 ? "0" : this.DataHeader.age;
      if (this.DataHeader && this.DataHeader.ageFormatted) {
        const parts = this.DataHeader.ageFormatted.split(' ');
        if(parts.length === 2){
          this.DataHeader.ageFormatted = this.formatAge(parts[0], parts[1]);
        }
      }
    },

    OnCamera(){ 
      this.$bvModal.show(this.modalIdCamera);   
    },

    SyncFileReader(file) {
      let self = this;
      let ready = false;
      let result = '';

      const sleep = function (ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }

      self.readAsDataURL = async function() {
          while (ready === false) {
            await sleep(100);
          }
          return result;
      }    

      const reader = new FileReader();
      reader.onloadend = function(evt) {
          result = evt.target.result;
          ready = true;
      };
      reader.readAsDataURL(file);
    },

    async addImage(e){
      this.msg = this.$t('Msg.LoadedSuccessfully')
      let droppedFiles = e.type === 'drop'?e.dataTransfer.files:e.target.files;     
     //var extension = "";
      if(!droppedFiles) return;     
      if(droppedFiles.length === 1){
        var filename = droppedFiles[0].name;
        this.Photo.fileName = filename;
        const fileReader = new this.SyncFileReader(droppedFiles[0]);
        const arrayBuffer = await fileReader.readAsDataURL();
        if(arrayBuffer){
          const img = document.getElementById("rm-photo");
          img.src = arrayBuffer;
        }    

        if(arrayBuffer.indexOf(',') !== -1){
           var b = arrayBuffer.split(',');    
           this.Photo.contents = b[1];  
           //this.files.push({"name":fileNameNoExtension,"Image":Image,"extension":extension,"base64":b[1],"description":"","code":code,"type":type,"new":true,"isreadonly":true});
        }
        var pos = filename.lastIndexOf('.');
        if(pos !== -1){          
          this.Photo.extension = filename.substring(pos).toUpperCase();
        }
        this.SavePhoto();        
      }
    },

    LoadPicture(){       
      this.$refs.input.click();
      this.$refs.input.value = "";       
    },

    onSelect: function(args) {
      const actions = {
          'LoadPicture': this.LoadPicture,
          'TakePicture': this.OnCamera,
          'RemoveUserPicture': this.RemovePicture,
      };

      const action = actions[args.item.id];
      if (action) {
          action.call(this); // Call the method in the context of the component
      } else {
          console.warn(`Unknown action: ${args.item.id}`);
      }
    },

    SavePhoto(){  
      try {
        !this.NotPhoto ? this.UpdatePhoto() : this.InsertPhoto();
      } catch (error) {
          console.error("Error saving photo:", error); // Error handling
      } finally {
          this.loadMenuItems(true); // Ensure this is always called
      }
    },

    InsertPhoto(){
      var data = {
        Entitycode:this.$route.params.id,
        contents:this.Photo.contents,
        extension:this.Photo.extension, 
        fileName:this.Photo.fileName  
      };
      DocumentManagementService.AddPhoto(data)
        .then((response) => {
            if(response.status == '200'){
              this.Photo = response.data;
              this.NotPhoto = false;
              setTimeout(() => 
                  this.showToast(
                    this.$t('RigthBar.pPhoto'),
                    this.msg
                ), 50); 
            }                           
        })
        .catch((error) => {
            if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        });  
    },

    UpdatePhoto(){
      var data = {
        Entitycode:this.$route.params.id,
        contents:this.Photo.contents,
        extension:this.Photo.extension, 
        fileName:this.Photo.fileName,   
      };

      DocumentManagementService.UpdatePatientPhoto(this.Photo.seqno,data)
          .then((response) => {
            if(response.status == '200'){
              setTimeout(() => 
                this.showToast(
                  this.$t('RigthBar.pPhoto'),
                  this.msg
                ), 50); 
            }                            
          })
          .catch((error) => {
              if (error.response) {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
          });  
    },
    
    async GetPhoto(){
      await DocumentManagementService.GetPatientPhoto(this.$route.params.id)
        .then((response) => {
          if(response.status == '200' && response.data){
            this.Photo = response.data;          
            if(this.Photo.contents !== null && this.Photo.contents !== ""){
              this.NotPhoto = false;
            }
          }                           
        })
        .catch((error) => {
            if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        });  
    },

    GoToPatientSummary(){
      if(!this.$store.state.isUsePatientInfo) return;// Early return if condition is not met

      const { id, recordid } = this.$route.params; // Destructure for easier access
      const currentRouteName = this.$router.currentRoute.name;
      const pRouteNames = ['patient', 'contact', 'allergy'];
      const cRouteNames = ['Clinical', 'vs', 'lognote-add', 'dailynote-add'];

      // Handle patient-related routes
      if (pRouteNames.some(route => this.$route.name.includes(route))) {
        if( currentRouteName == "patient-details") {
            this.showToast(
              this.$t('MdPatientInfoBox.PatientInfo'),
              this.message
            );
        } else {
            this.$router.push({ name: "patient-details", params: { id: id } })
              .catch(err => console.error('Navigation error:', err)); // Improved error handling
        }
        return;
      }
      // Handle clinical-related routes
      if(cRouteNames.some(route => this.$route.name.includes(route))){ 
          if( currentRouteName == "Clinical-PatientInfo") {
              this.showToast(
                this.$t('MdPatientInfoBox.PatientInfo'),
                this.message
              );
          } else {
              this.$router.push({ 
                name: 'Clinical-PatientInfo', 
                params: { id, recordid } 
            }).catch(err => console.error('Navigation error:', err)); // Improved error handling
          }
      }
    },

    RemovePicture(){
      if(this.NotPhoto)return;      
      this.Photo.contents = '',
      this.Photo.extension = '', 
      this.Photo.fileName = '', 
      this.msg = this.$t('Msg.RemoveSuccessfully')
      this.SavePhoto() 
    },
    // Helper function to display toast
    showToast(titleKey, msgKey, variant = "success") {
        this.$bvToast.toast( msgKey, {
            title: titleKey,
            autoHideDelay: 4000,
            variant: variant
        });
    },
    searchOpt(evt) {
      EventBus.$emit('onSearchOpt', evt.target.value);
    }
    ,
    resetNow(){
      this.$refs["search_"].value = "";
      const e = {
        target: {
          value: ""
        }
      }
      this.searchOpt(e); 
    },
  },
  created(){   
    EventBus.$on("UpdateMarqueeRightBar", function () {     
     this.GetDataHeader();
    }.bind(this));

    EventBus.$on("PhotoWasTaken", function (data) {
      const img = document.getElementById("rm-photo");
      img.src = data;
      if(data.indexOf(',') !== -1){
           var b = data.split(',');              
           if(b[0].indexOf(';') !== -1){
            var c = b[0].split(';');  
            if(c[0].indexOf('/') !== -1){
              var d = c[0].split('/');
              this.Photo.extension = "."+d[1]; 
              this.Photo.contents = b[1]; 
              this.Photo.fileName = ""; 
              this.msg = this.$t('Msg.SavedSuccessfully')            
              this.SavePhoto();
            }
           } 
      }
    }.bind(this));
  },
  mounted(){  
    this.GetDataHeader();
    this.GetPhoto()
      .then(() => {
        // First function has finished, call the second function
        this.loadMenuItems();     
    });
    document.getElementById("target-menu-righmenu").focus();
  },
  beforeDestroy () {     
    EventBus.$off('UpdateMarqueeRightBar'); 
  }
};
  
</script>
